<h2 mat-dialog-title>{{ 'client.relatives.deactivate.title' | transloco }}</h2>
<mat-dialog-content>
	<p>
		{{
			'client.relatives.deactivate.confirmation'
				| transloco: { firstName: relative.firstName, lastName: relative.lastName }
		}}
	</p>
	<lvr-field [label]="'client.relatives.deactivate.doublecheck' | transloco">
		<mat-form-field lvrInput class="full-width">
			<input
				matInput
				[(ngModel)]="confirmationInput"
				[placeholder]="'client.relatives.deactivate.insert_name' | transloco: { lastName: relative.lastName }"
			/>
		</mat-form-field>
	</lvr-field>
</mat-dialog-content>
<mat-dialog-actions class="actions-row">
	<lvr-button
		variant="secondary"
		[label]="'base.button.cancel' | transloco"
		[type]="'button'"
		mat-dialog-close
		icon="disabled_by_default"
	>
	</lvr-button>
	<lvr-button
		variant="primary"
		[label]="'client.relatives.deactivate.deactivate' | transloco"
		[loadingLabel]="'client.relatives.deactivate.deactivating' | transloco"
		[loading]="loading()"
		[disabled]="!isDeactivateEnabled()"
		[type]="'button'"
		(clicked)="deactivateUser()"
		icon="delete"
	>
	</lvr-button>
</mat-dialog-actions>
